export default class UndefinedEnvironmentVariableError extends Error {
    constructor(env: string) {
        super(`${env} environment variable is not defined`);
    }
}
